module.exports = __webpack_public_path__ + "static/img/sijie.caacf8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/sijie.png
// module id = 6S9+
// module chunks = 0